import i18n from 'i18next';
import React, { createContext, useState, useEffect, useContext } from 'react';
import { SET_CONFIG_LANGUAGE } from 'services/gamecentreService';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [userLanguage, setUserLanguage] = useState('en');
  const [direction, setDirection] = useState('ltr');

  const inIframe = window.location !== window.parent.location;

  const setConfigLanguageHandler = (e) => {
    const { detail: { configLanguage, userLanguage } } = e
    setLanguage(configLanguage);
    setUserLanguage(userLanguage);
  }

  useEffect(() => {
    if (!inIframe) return;
    window.addEventListener(SET_CONFIG_LANGUAGE, setConfigLanguageHandler);
    return () => window.removeEventListener(SET_CONFIG_LANGUAGE, setConfigLanguageHandler);
  }, []);

  useEffect(() => {
    // Detect the `lang` parameter from the URL and set the language
    const params = new URLSearchParams(window.location.search);
    const lang = params.get('lang');
    const userLang = params.get('userLang');
    if (lang) setLanguage(lang);
    if (userLang) setUserLanguage(userLang);
  }, []);

  useEffect(() => {
    // Update the document's `dir` attribute whenever the language changes
    setDirection(language === 'ar' ? 'rtl' : 'ltr');
    i18n.changeLanguage(language)
  }, [language, direction]);

  const toggleLanguage = () => {
    setLanguage((prevLang) => (prevLang === 'en' ? 'ar' : 'en'));
  };

  return (
    <LanguageContext.Provider value={{
      language,
      userLanguage,
      direction,
      toggleLanguage,
      rtlView: direction === 'rtl'
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => useContext(LanguageContext);